export const common = {
  // Navigation
  home: '首頁',
  services: '服務',
  programs: '計劃',
  members: '會員/公司',
  about: '關於我們',
  
  // Hero Section
  heroTitle: '我們幫助台灣企業',
  heroSubtitle: '進入美國市場',
  heroDescription: '為台灣公司擴展到美國提供全面支持。從市場進入到業務設立，我們提供您所需的專業知識和資源。',
  createProfile: '建立檔案',
  
  // Common
  learnMore: '了解更多',
  getStarted: '開始使用',
  contactUs: '聯絡我們',
};